/* globals dataLayer, adobe */
(function (window, angular, undefined) {
    angular.module('formApp')
        .controller('stepFourCtrl', ['$scope', '$rootScope', '$q', 'FormService', 'formData', '$state', '$log', 'updateHeader', 'LoadingInterceptor', 'sessionService', '$window', 'errorHandler', 'dataLayerService', 'moment',
            function ($scope, $rootScope, $q, formService, formData, $state, $log, updateHeader, loadingInterceptor, sessionService, $window, errorHandler, dataLayerService, moment) {
                var mboxName = 'questionsStep4NewQB';

                $scope.isEcover = false;
                $scope.isEquote = false;
                
                if ($state.params.type === 'topNav') {
                    var navMethod = $state.params.type;
                }
                var evt = new CustomEvent("currentStep", {detail: {step:"4"}});
                window.dispatchEvent(evt);
                console.log('event dispatched',evt);
                
                sessionService.start();

                if (sessionStorage.getItem('eQuote')) {                 
                    sessionStorage.setItem('currentRefreshState', 'step-4e');
                } else if (sessionStorage.getItem('eCoverNote')) {                 
                    sessionStorage.setItem('currentRefreshState', 'questions-ec');
                    mboxName = 'questionsStep4Ecover';
                    $scope.isEcover = true;

                }
                else {
                    sessionStorage.setItem('currentRefreshState', 'step-4');
                }   
                
                if (sessionStorage.getItem('journey') === 'combined'){
                    $rootScope.mainJourney = false;
                    $rootScope.journeyClass = 'combined';
                }
                if (sessionStorage.getItem('journey') === 'single'){
                    $rootScope.mainJourney = true;
                    $rootScope.journeyClass = 'single';
                }
                
                function returnPetAge(dob){
                    var a = moment();
                    var b = moment(dob);
                  
                    var years = a.diff(b, 'year');
                    b.add(years, 'years');
                    
                    var months = a.diff(b, 'months');
                    b.add(months, 'months');
                    
                    var days = a.diff(b, 'days');
    
                    var petAge = {
                        "years": years,
                        "months": months,
                        "days": days
                    };
                     return petAge; 
                }

                // block journey if any of the following scenarios met
                $scope.$watch('formData.pets', function(newVal) {
                   // console.log('pets', newVal);
                    var blocked = false;
                    newVal.forEach(function (pet) {
                        if($scope.isBlocked(pet)) {
                            formService.postBlockedQuestions(pet, pet.uri, $scope.insuranceApplicationUri);
                            blocked = true;
                        }
                    });
                    $scope.blocked = blocked;
                }, true);

                // check blocked scenarios for each pet
                $scope.isBlocked = function(pet) {
                    if(pet.extraQuestions && (pet.extraQuestions.signsOfIllnessOrInjuryUwq === 'Y' && pet.extraQuestions.beenInsuredBefore === 'Y') || pet.extraQuestions && (pet.extraQuestions.beenInsuredBefore === 'Y' && (pet.extraQuestions.everSeenByVetDetails && pet.extraQuestions.everSeenByVetDetails !== ""))) {
                        return true;
                    } else {
                        return false;
                    }
                };
                 $scope.showWhatHappens = function(pet) {
                    if (pet.extraQuestions) {
                      if ( (pet.extraQuestions.signsOfIllnessOrInjuryUwq === "Y" && pet.extraQuestions.signsOfIllnessOrInjuryUwqDetails && pet.extraQuestions.everSeenByVetDetails !== "") ||
                          (pet.extraQuestions.everSeenByVet === "Y" && pet.extraQuestions.everSeenByVetDetails && pet.extraQuestions.everSeenByVetDetails !== ""))
                      {
                        return true;
                      } else {
                        return false;
                      }
                    } else {
                      return false;
                    }
                 };
                
                $scope.$watch('gatewayReady', function () {
                    if ($scope.gatewayReady === true && sessionStorage.getItem('formStateUri')) {
                        formService.setApplicationId(sessionStorage.getItem('formStateUri'));
                        if (sessionStorage.getItem('eQuote') !== 'true') {
                            sessionService.heartbeat();
                        }

                        loadingInterceptor.incrementRequests();
                        refresh().then(function (response) {
                       
                            loadingInterceptor.decrementRequests();
                            $scope.formData.declarations = {};
                            var eQuoteFlag = sessionStorage.getItem('eQuote');
                            $rootScope.eQuote = eQuoteFlag;
                            if (sessionStorage.getItem('eQuoteCn')) {
                                $rootScope.eQuoteCoverNote = true;
                            }
                            console.log(eQuoteFlag);
                            $scope.isEquote = eQuoteFlag ? true : false;

                            // quote ref number added to UI when call centre scenario 
                            $scope.quoteRef = response.data.officeUseOnly.quoteReference;

                            // show UW questions based on the productID/scenarios
                            $scope.officeUseOnly = response.data.officeUseOnly.params;
                            if($scope.officeUseOnly) {
                                var charityCodes = ['CY','CP','BX','NC']; //charity code
                                var breederCodes = ['PK']; //breeder code
                                $scope.isCharity = charityCodes.includes($scope.officeUseOnly.prodId);
                                $scope.isBreeder = breederCodes.includes($scope.officeUseOnly.prodId);
                                $scope.isVet = ($scope.officeUseOnly.prodId === "IV") && ($scope.officeUseOnly.partnerType === "VETS");
                                $scope.isChipper = ($scope.officeUseOnly.prodId === "IV") && ($scope.officeUseOnly.partnerType === "CHIPPERS");
                                $scope.charityNotVoucher = $scope.isCharity && $scope.officeUseOnly.voucher && $scope.officeUseOnly.voucher === 'false';

                                //UW Ecover coverted to Equote -> from Paris and sent to web(convFrm = C & not Voucher ) 
                                //Need to display Ecover UW Questions
                                var isConvertedFromEcovertoEquote = $scope.isEquote && $scope.officeUseOnly.convFrm === 'C' && $scope.charityNotVoucher && $scope.officeUseOnly.voucher === 'false';
                                var isEcoverAndCharityNotVoucher = $scope.isEcover && $scope.charityNotVoucher;

                                //Setting Flags to display UWQ based on scenarios
                                $scope.everSeenByVetFlag = ! ( isEcoverAndCharityNotVoucher || isConvertedFromEcovertoEquote );
                                $scope.signsOfIllnessOrInjuryFlag = true;
                                $scope.insuranceDeclinedBeforeFlag = ! ( isEcoverAndCharityNotVoucher || isConvertedFromEcovertoEquote );
                                $scope.beenInsuredBeforeFlag = ! ( isEcoverAndCharityNotVoucher || isConvertedFromEcovertoEquote );
                                $scope.petHealthHistoryDocumentFlag = isEcoverAndCharityNotVoucher || isConvertedFromEcovertoEquote;
                            }
                            $scope.pet = response.data.application.pets[0];
                            $scope.petType = response.data.application.pets[0].type;
                            $scope.formData.pets = response.data.application.pets;
                            $scope.formData.cover = response.data.application.cover;
                            $scope.formData.aboutYou = response.data.application.aboutYou;

                            // Add extra text for declarations if policy start date in future
                            var policyStartDate = $scope.formData.cover.startDate;
                            $scope.afterStartDate = moment(policyStartDate).isAfter();

                            // These need to reset if the user comes back to the page
                            $scope.formData.declarations.informationIsTrueAndComplete = {};
                            $scope.formData.declarations.readTermsAndConditions = {};

                            $scope.formData = formData;

                            if ($scope.formData.pets.length > 1) {
                                updateHeader.petType = 'multipet';
                                $scope.petType = '';
                                var i;
                                for (i = 0; i < $scope.formData.pets.length; i++) {
                                    if($scope.formData.pets[i].type === 'dog'){
                                        $scope.petType = $scope.formData.pets[i].type;
                                    }
                                }
                            }
                            
                            // illness cover start date - if applicable
                            illnessCheck(response);
            
                            formData.pets.forEach(function (pet) {                  
                                if (pet.chosenCover) {
                                    switch (pet.chosenCover.productLine.toLowerCase()) {
                                        case 'essential':
                                            $scope.hasEssentialCover = true;
                                            break;
                                        case 'c4l':
                                            $scope.hasC4lCover = true;
                                            break;
                                        case 'rabbit':
                                            $scope.hasC4lCoverRabbit = true;
                                            break;
                                    }
                                }
                            });
            

                            //GA STUFF===========
                            var pc = $scope.formData.aboutYou.postCode;

                            dataLayer.push({
                                'event': 'dataAvailable',
                                'funnelName': parseInt(dataLayerService.setFunnelName()),
                                'funnelVersion': dataLayerService.setFunnel(),
                                'funnelPageNumber': 4,
                                'funnelSfc': sessionStorage.getItem('eCoverJourney') === 'recognised' || sessionStorage.getItem('eCoverJourney') === 'return-rec',
                                'funnelFc': sessionStorage.getItem('eCoverJourney') === 'retrieveQB',
                                'funnelFcRtn': sessionStorage.getItem('eCoverJourney') === 'return' || sessionStorage.getItem('eCoverJourney') === 'return-rec',
                                // 'petDetailsPosition': 1,
                                'environment': window.location.hostname,
                                'bravCode': '',
                                'campaignCode': dataLayerService.campaignCode(),
                                'partnerName': dataLayerService.partnerName(),
                                'postcode': pc.split(" ", 1).toString(),
                                'quoteId': $window.sessionStorage.getItem('formStateUri'),
                                'policyVariables': $rootScope.gaquoteVariables,
                                'quoteRetrieval': dataLayerService.setRetrieveMode(),
                                'numberOfPets': $scope.formData.pets.length,
                                'multipetFlag': dataLayerService.multiPetTest($scope.formData.pets.length),
                                "eQuoteFlag": sessionStorage.getItem('eQuote'),
                            });     

                            //GA STUFF======

                            if (window.sessionCamRecorder) {
                                if (window.sessionCamRecorder.createVirtualPageLoad) {
                                    window.sessionCamRecorder.createVirtualPageLoad('stepFour');
                                }
                            }
                        });
                    }

                    function refresh() {
                        return formService.getApplication();
                    }

                });

                $scope.overSixMonths = function (pet,test){
                    if (pet.details !== undefined && pet.details.dateOfBirth !== undefined) {
                        var dob = pet.details.dateOfBirth;
                        var diffMonths = moment().diff(moment(dob), 'months', true);
                        if (diffMonths > 6) {
                            return true;                           
                        }
                        else {
                            return false;
                        }
                    }
                };

                $scope.formData = formData;

                if ($scope.formData.pets.length > 1) {
                    updateHeader.petType = 'multipet';
                }

                formData.pets.forEach(function (pet) {
                    if (pet.chosenCover) {
                        switch (pet.chosenCover.productLine.toLowerCase()) {
                            case 'essential':
                                $scope.hasEssentialCover = true;
                                break;
                            case 'c4l':
                                $scope.hasC4lCover = true;
                                break;
                            case 'rabbit':
                                $scope.hasC4lCoverRabbit = true;
                                break;
                        }
                    }
                });

                $scope.countdown = function (model, constraints) {
                    var lengthConstraint = constraints.filter(function (c) {
                        return c.type === 'length' && c.hasOwnProperty('max');
                    });
                    if (typeof model === 'undefined' || typeof lengthConstraint === 'undefined') {
                        return '';
                    }
                    if (model.$viewValue && model.$viewValue.length < lengthConstraint[0].max) {
                        return lengthConstraint[0].max - model.$viewValue.length + ' character' + (lengthConstraint[0].max - model.$viewValue.length!== 1 ? 's remaining':' remaining');
                    } else if(model.$viewValue && model.$viewValue.length >= lengthConstraint[0].max) {
                        //accessibility notify user no characters left
                        return '0 characters remaining';
                    } else {
                        //accessibility notify user how many characters allowed
                        return lengthConstraint[0].max + ' characters remaining';
                    } 
                };

                function illnessCheck(response) {
                    // illness cover start date - if applicable
                    if (response.data.officeUseOnly.params && response.data.officeUseOnly.params.parisIllnessStartDate) {
                        $scope.illnessStartDate = moment(response.data.officeUseOnly.params.parisIllnessStartDate, 'YYYY-MM-DD').toDate();
                    }
                    if (response.data.officeUseOnly.params && response.data.officeUseOnly.params.voucher === 'true' && $scope.illnessStartDate && moment($scope.formData.cover.startDate, 'YYYY-MM-DD').isBefore(moment($scope.illnessStartDate))) {
                        $scope.eCoverNoteVoucher = true;
                    }
                    if (response.data.officeUseOnly.params && response.data.officeUseOnly.params.coverNoteEndDate) {
                        $scope.freeCoverExpired = moment(response.data.officeUseOnly.params.coverNoteEndDate, 'DD/MM/YYYY').startOf('day').diff(moment().startOf('day'), 'days') < 0;
                    }
                }

                $scope.clearQuestions = function (pet, questions) {
                    questions.forEach(function (question) {
                        // check if any question filled in first
                        if(pet.extraQuestions) {
                            delete pet.extraQuestions[question];
                        }
                    });
                };

                $scope.submit = function (e) {
                    submitQuestions();
                };

                function submitQuestions() {
                    var promises = [];
                    loadingInterceptor.incrementRequests();
                    $scope.formData.pets.forEach(function (pet) {
                        if ($scope.overSixMonths(pet)){
                            promises.push(formService.postQuestions(pet, pet.uri, $scope.insuranceApplicationUri));
                        }
                        else{
                            pet.extraQuestions.beenInsuredBefore = "N";
                            promises.push(formService.postQuestions(pet, pet.uri, $scope.insuranceApplicationUri));  
                        }
                       
                    });
                    return $q.all(promises).then(function (response) {
                        return formService.postDeclarations($scope.formData.declarations);
                    }).then(function (response) {
                        loadingInterceptor.decrementRequests();
                        if (sessionStorage.getItem('eQuote')) {
                            $state.go('step-5e', { forward: true });
                        } else if (sessionStorage.getItem('eCoverNote')) {
                            $state.go('pay-ec', { forward: true });
                        }
                        else if (sessionStorage.getItem('tandtDetailsTest')) {
                            $state.go('step-5-details', { forward: true });
                        }
                        else {
                            $state.go('step-5', { forward: true });
                        }

                    }).catch(function (error) {
                        errorHandler.reportErrors(error, 'redirect', 'tech');
                    });
                }
                function reportErrors(fault) {
                    if (fault.message) {
                        $log.error(fault.message);
                    } else {
                        $log.error(JSON.stringify(fault));
                    }
                }
                

            }]);
})(window, window.angular);